"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isReactNative = exports.isNode = exports.isBrowser = void 0;
var isBrowser = function () { return typeof window !== 'undefined' && typeof window.document !== 'undefined'; };
exports.isBrowser = isBrowser;
var isNode = function () { return typeof process !== 'undefined' && process.versions != null && process.versions.node != null; };
exports.isNode = isNode;
var isReactNative = function () { return typeof navigator != 'undefined' && navigator.product == 'ReactNative'; };
exports.isReactNative = isReactNative;
exports.default = {
    isBrowser: exports.isBrowser,
    isNode: exports.isNode,
    isReactNative: exports.isReactNative
};
//# sourceMappingURL=platform.js.map